import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  Multicountry,
  MultiCountryDraftData,
} from '../../../shared/interfaces/create-surveys.interface';
import {
  MultiCountryFeasCpiData,
  MultiCountryRunFeasibilityInfo,
} from '../../shared/ui/multicountry/multi-country-draft/multi-country-draft.interface';

@Injectable({
  providedIn: 'root',
})
export class MultiCountryDraftService {
  private _multiCountryDraftData$ = new BehaviorSubject<MultiCountryDraftData>({
    countryData: [],
  });
  private _mcFeasCpiDefaultValue = {} as MultiCountryFeasCpiData;
  private _mcFeasCpiData$ = new BehaviorSubject<MultiCountryFeasCpiData>(
    this._mcFeasCpiDefaultValue
  );
  private _mcRunFeasibilityInfoDefault = <MultiCountryRunFeasibilityInfo>{};
  private _mcRunFeasibilityInfo$ =
    new BehaviorSubject<MultiCountryRunFeasibilityInfo>(
      this._mcRunFeasibilityInfoDefault
    );

  constructor() {}

  setMultiCountryDraftData(data: MultiCountryDraftData) {
    this._multiCountryDraftData$.next(data);
  }

  getMultiCountryDraftData() {
    return this._multiCountryDraftData$.asObservable();
  }

  setMultiCountryFeasCpiData(data: MultiCountryFeasCpiData) {
    this._mcFeasCpiData$.next(data);
  }

  getMultiCountryFeasCpiData(): Observable<MultiCountryFeasCpiData> {
    return this._mcFeasCpiData$.asObservable();
  }

  setMultiCountryRunFeasibilityInfo(data: MultiCountryRunFeasibilityInfo) {
    this._mcRunFeasibilityInfo$.next(data);
  }

  setMultiCountryRunFeasibilityInfoDefault() {
    this._mcRunFeasibilityInfo$.next(this._mcRunFeasibilityInfoDefault);
  }

  getMultiCountryRunFeasibilityInfo(): Observable<MultiCountryRunFeasibilityInfo> {
    return this._mcRunFeasibilityInfo$.asObservable();
  }

  extractBaseSurveyTitleFromMcSurveyTitle(multiCountrySurvey: Multicountry) {
    // regex to remove default title creation
    const extractDefaultKey = new RegExp(
      ` - MC-${multiCountrySurvey.short_Code}-${multiCountrySurvey.language.transalte_code}`,
      'g'
    );
    // regex to remove any old country code used or changed later in survey (exact match)
    const extractCountryCode = new RegExp(
      `^${multiCountrySurvey.short_Code}$`,
      'g'
    );
    // regex to remove any old language code used or changed later in survey (exact match)
    const extractLanguageCode = new RegExp(
      `^${multiCountrySurvey.language.transalte_code}$`,
      'g'
    );
    return multiCountrySurvey.surveyTitle
      .replace(extractDefaultKey, '')
      .replace(extractCountryCode, '')
      .replace(extractLanguageCode, '');
  }
}
